export const INIT_AUTH_REQUEST_DATA = 'INIT_AUTH_REQUEST_DATA';
export const SET_AUTH_REQUEST_DATA = 'SET_AUTH_REQUEST_DATA';
export const ERROR_AUTH_REQUEST_DATA = 'ERROR_AUTH_REQUEST_DATA';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const CLEAR_AUTH_TOKEN = 'CLEAR_AUTH_TOKEN';
export const SET_ROLE_TYPE = 'SET_ROLE_TYPE';
export const CLEAR_ROLE_TYPE = 'CLEAR_ROLE_TYPE';


export function initAuthenticationRequestData() {
  return {type: INIT_AUTH_REQUEST_DATA};
}

export function setAuthenticationRequestData(data) {
  return {type: SET_AUTH_REQUEST_DATA, payload: data};
}

export function errorAuthenticationRequestData(error) {
  return {type: ERROR_AUTH_REQUEST_DATA, payload: error};
}


export function setAuthToken(token) {
  return { type: SET_AUTH_TOKEN, payload: token };
}

export function clearAuthToken() {
  return { type: CLEAR_AUTH_TOKEN };
}

export function setRoleType(roleType) {
  return { type: SET_ROLE_TYPE, payload: roleType };
}

export function clearRoleType() {
  return { type: CLEAR_ROLE_TYPE };
}
